import moment from 'moment-timezone'
import {DEFAULT_TIMEZONE} from '@/constants/timezone'

export const setDefaultTimeZone = (timezone: string) => {
    moment.tz.setDefault(timezone || DEFAULT_TIMEZONE)
}

export const disabledDatesBeforeOctober2025 = (date: moment.Moment) => {
    const momentUK = moment.tz(DEFAULT_TIMEZONE)

    return date < momentUK.clone().set({year: 2025, month: 9, date: 1}).startOf('day')
}
